// lib
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// components
import { Dropdown } from 'primereact/dropdown'

const itemTemplate = option => (option.hidden ? null : <span dangerouslySetInnerHTML={{ __html: option.text }}></span>)
const valueTemplate = option =>
  option ? <span dangerouslySetInnerHTML={{ __html: option.text }}></span> : 'Please select...'

const TagsControls = ({ model, onConfigChange }) => {
  const { config, codeBooks = [] } = model

  const codeBooksOptions = useMemo(
    () =>
      codeBooks.map(codebook => {
        return {
          key: codebook.title,
          text: codebook.title
        }
      }),
    [codeBooks]
  )

  return 0 < codeBooksOptions.length ? (
    <div className="p-field p-col-param p-col-param-wide">
      <Dropdown
        className="p-dropdown-rounded"
        value={config.codebook || codeBooksOptions[0].text}
        options={codeBooksOptions}
        optionValue="key"
        optionLabel="text"
        optionDisabled="disabled"
        itemTemplate={itemTemplate}
        valueTemplate={valueTemplate}
        fixedDropdownDir="bottom"
        onChange={event => onConfigChange('codebook', '*' == event.value ? null : event.value)}
      />
    </div>
  ) : null
}

TagsControls.propTypes = {
  model: PropTypes.object,
  onConfigChange: PropTypes.func
}

TagsControls.displayName = 'TagsControls'

export default TagsControls
